import { render, staticRenderFns } from "./ProductEditDescription.vue?vue&type=template&id=32b66730&scoped=true&"
import script from "./ProductEditDescription.vue?vue&type=script&lang=js&"
export * from "./ProductEditDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditDescription.vue?vue&type=style&index=0&id=32b66730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b66730",
  null
  
)

export default component.exports